import React, { Component } from 'react';
import _ from 'underscore'

class Accordion extends Component {
    constructor (props) {
        super(props);

        this.state = {
            expanded: true
        };

        this.handleExpand = this.handleExpand.bind(this);
    }

    handleExpand (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            expanded: !this.state.expanded
        });
    }

    render () {
        const { expanded } = this.state;
        const { values, title} = this.props;
        
        if (
            (_.isArray(values) && !values.length) ||
            !values
         ) return null;

        return (<div
            className={'panel panel-body overview-group' + (expanded ? ' open ' : ' closed ')}>
            <a href="#" onClick={this.handleExpand}>
                <label htmlFor="">{title}</label>
                <span>{expanded ? <i className="fa fa-caret-up"/> :
                    <i className="fa fa-caret-down"/>
                }</span>
            </a>
            {expanded ? <ul>{values}</ul> : null}
        </div>)
    }
}

Accordion.propTypes = {};

export default Accordion;
